import {
    GET_ADMIN_JOB_REQUEST, GET_ADMIN_JOB_ERROR, GET_ADMIN_JOB_SUCCESS,
    ADD_ADMIN_JOB_REQUEST, ADD_ADMIN_JOB_ERROR, ADD_ADMIN_JOB_SUCCESS,
    UPDATE_ADMIN_JOB_REQUEST, UPDATE_ADMIN_JOB_ERROR, UPDATE_ADMIN_JOB_SUCCESS,
    DELETE_ADMIN_JOB_REQUEST, DELETE_ADMIN_JOB_ERROR, DELETE_ADMIN_JOB_SUCCESS,
} from "./types";

import { BASEURL } from "../../constant/config.js";

const axios = require("axios");

export const getAdminJob = (token, menu_id) => (dispatch) => {
    dispatch({ type: GET_ADMIN_JOB_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/adminJob`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { menu_id }
    })
        .then((response) => {
            return dispatch({ type: GET_ADMIN_JOB_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_ADMIN_JOB_ERROR,
                payload: error.response,
            });
        });
};

export const addAdminJob = (token, data, menu_id) => (dispatch) => {



    dispatch({ type: ADD_ADMIN_JOB_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/adminJob`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { job_title: data.adminJobName, is_active: data.check, menu_id },
    })
        .then((response) => {

            return dispatch({ type: ADD_ADMIN_JOB_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_ADMIN_JOB_ERROR,
                payload: error.response,
            });
        });
};

export const updateAdminJob = (token, data, id) => (dispatch) => {
    dispatch({ type: UPDATE_ADMIN_JOB_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/adminJob/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { job_title: data.adminJobName, is_active: data.check },
    })
        .then((response) => {

            return dispatch({ type: UPDATE_ADMIN_JOB_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_ADMIN_JOB_ERROR,
                payload: error.response,
            });
        });
};

export const deleteAdminJob = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_ADMIN_JOB_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/adminJob/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {

            return dispatch({ type: DELETE_ADMIN_JOB_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_ADMIN_JOB_ERROR,
                payload: error.response,
            });
        });
};
